import React from 'react';
import { string, func, arrayOf, shape, oneOf, oneOfType, bool, number, object, node } from 'prop-types';
import { Button } from "../../../../elements/Button";
import { size } from "../../../../../utils/size";
import { CHECK_IN, CHECK_OUT, GUESTS, LOCATION, SEARCH } from "../../../../../utils/default-strings";
import { ICON_NAMES } from "../../../../elements/Icon";
import { Dropdown } from "../../../../inputs/Dropdown";
import { CounterDropdown } from "../../../../inputs/CounterDropdown";
import { DateRangePicker } from "../../../../inputs/DateRangePicker";
export var Component = function Component(_ref) {
  var dateRangePickerLocaleCode = _ref.dateRangePickerLocaleCode,
      datesCheckInLabel = _ref.datesCheckInLabel,
      datesCheckOutLabel = _ref.datesCheckOutLabel,
      datesInputFocusedInput = _ref.datesInputFocusedInput,
      datesInputOnFocusChange = _ref.datesInputOnFocusChange,
      datesInputValue = _ref.datesInputValue,
      getIsDayBlocked = _ref.getIsDayBlocked,
      guestsInputLabel = _ref.guestsInputLabel,
      guestsInputValue = _ref.guestsInputValue,
      guestsPopupId = _ref.guestsPopupId,
      isCalendarIconDisplayed = _ref.isCalendarIconDisplayed,
      isDateRangePickerLoading = _ref.isDateRangePickerLoading,
      locationInputLabel = _ref.locationInputLabel,
      locationInputValue = _ref.locationInputValue,
      locationOptions = _ref.locationOptions,
      maximumGuestsInputValue = _ref.maximumGuestsInputValue,
      onInputChange = _ref.onInputChange,
      searchButton = _ref.searchButton,
      willLocationDropdownOpenAbove = _ref.willLocationDropdownOpenAbove;
  return React.createElement("div", {
    className: "inputs-container"
  }, !!size(locationOptions) && React.createElement("div", {
    className: "input-container location-input-container"
  }, React.createElement(Dropdown, {
    icon: ICON_NAMES.MAP_PIN,
    label: locationInputLabel,
    name: "location",
    onChange: onInputChange,
    options: locationOptions,
    value: locationInputValue,
    willOpenAbove: willLocationDropdownOpenAbove
  })), React.createElement("div", {
    className: "input-container dates-input-container"
  }, React.createElement(DateRangePicker, {
    endDatePlaceholderText: datesCheckOutLabel,
    focusedInput: datesInputFocusedInput,
    getIsDayBlocked: getIsDayBlocked,
    isCalendarIconDisplayed: isCalendarIconDisplayed,
    isLoading: isDateRangePickerLoading,
    localeCode: dateRangePickerLocaleCode,
    name: "dates",
    onChange: onInputChange,
    onFocusChange: datesInputOnFocusChange,
    startDatePlaceholderText: datesCheckInLabel,
    value: datesInputValue,
    willOpenAbove: willLocationDropdownOpenAbove
  })), React.createElement("div", {
    className: "input-container guests-input-container"
  }, React.createElement(CounterDropdown, {
    counterName: "guests",
    counterValue: guestsInputValue,
    dropdownLabel: guestsInputLabel,
    maximumCounterValue: maximumGuestsInputValue,
    onChange: onInputChange,
    popupId: guestsPopupId
  })), React.createElement("div", {
    className: "button-container"
  }, searchButton));
};
Component.displayName = 'SearchFields';
Component.defaultProps = {
  dateRangePickerLocaleCode: undefined,
  datesCheckInLabel: CHECK_IN,
  datesCheckOutLabel: CHECK_OUT,
  datesInputFocusedInput: undefined,
  datesInputOnFocusChange: Function.prototype,
  datesInputValue: undefined,
  getIsDayBlocked: Function.prototype,
  guestsInputLabel: GUESTS,
  guestsInputValue: undefined,
  guestsPopupId: undefined,
  isCalendarIconDisplayed: undefined,
  isDateRangePickerLoading: undefined,
  locationInputLabel: LOCATION,
  locationInputValue: undefined,
  locationOptions: null,
  maximumGuestsInputValue: undefined,
  searchButton: React.createElement(Button, {
    icon: ICON_NAMES.SEARCH,
    isFormSubmit: true,
    isRounded: true
  }, SEARCH),
  willLocationDropdownOpenAbove: false,
  onInputChange: Function.prototype
};
Component.propTypes = process.env.NODE_ENV !== "production" ? {
  dateRangePickerLocaleCode: string,
  datesCheckInLabel: string,
  datesCheckOutLabel: string,
  datesInputFocusedInput: string,
  datesInputOnFocusChange: func,
  datesInputValue: shape({
    endDate: object,
    startDate: object
  }),
  getIsDayBlocked: func,
  guestsInputLabel: string,
  guestsInputValue: oneOfType([string, number]),
  guestsPopupId: string,
  isCalendarIconDisplayed: bool,
  isDateRangePickerLoading: bool,
  locationInputLabel: string,
  locationInputValue: string,
  locationOptions: arrayOf(shape({
    indent: oneOf([0, 1, 2, 3, 4, 5]),
    text: string.isRequired,
    value: oneOfType([bool, number, string])
  })),
  maximumGuestsInputValue: number,
  onInputChange: func,
  searchButton: node,
  willLocationDropdownOpenAbove: bool
} : {};